/* SIMI first-visit newsletter popup. */
(function () {
  'use strict';

  var storageKey = 'simi-newsletter-popup-state';

  function init(popup) {
    var closeButtons = popup.querySelectorAll('[data-simi-newsletter-close]');
    var success = Boolean(popup.querySelector('[data-simi-newsletter-success]'));
    var hasError = Boolean(popup.querySelector('[data-simi-newsletter-error]'));
    var timer;

    function getState() {
      try {
        return window.localStorage.getItem(storageKey);
      } catch (_error) {
        return null;
      }
    }

    function setState(value) {
      try {
        window.localStorage.setItem(storageKey, value);
      } catch (_error) {
        // The popup still works when storage is unavailable.
      }
    }

    function openPopup() {
      if (!popup.open) popup.showModal();
    }

    function closePopup(state) {
      if (!popup.open) return;
      window.clearTimeout(timer);
      if (state) setState(state);
      popup.classList.add('is-closing');
      window.setTimeout(function () {
        popup.close();
        popup.classList.remove('is-closing');
      }, 200);
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePopup(success ? 'subscribed' : 'dismissed');
      });
    });

    popup.addEventListener('click', function (event) {
      if (event.target === popup) closePopup('dismissed');
    });

    popup.addEventListener('cancel', function (event) {
      event.preventDefault();
      closePopup('dismissed');
    });

    if (success || hasError) {
      if (success) setState('subscribed');
      openPopup();
      return;
    }

    if (getState()) return;
    timer = window.setTimeout(openPopup, 20000);
  }

  function boot() {
    document.querySelectorAll('[data-simi-newsletter-popup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
